import type { FilterValues } from '@src/components/FilterDropDown/FilterDropDown.interfaces';
import { translateString } from '@src/util/intl/translateString';

export const REAL_TIME_FILTER_FIELD = {
  WORK_SHIFT: 'workShiftId',
  WORK_JOURNEY: 'workJourneyConfigId',
  USER: 'employeeId',
  STATUS: 'status',
  COST_CENTERS: 'costCenterIds',
} as const;

type RealTimeStructuralSelection = {
  workShiftId: string;
  workJourneyConfigId: string;
  employeeId: string;
};

export const STRUCTURAL_FILTER_LABEL_IDS = {
  [REAL_TIME_FILTER_FIELD.WORK_SHIFT]: 'workJourney.realTime.filter.shift',
  [REAL_TIME_FILTER_FIELD.WORK_JOURNEY]: 'workJourney.realTime.filter.journey',
  [REAL_TIME_FILTER_FIELD.USER]: 'workJourney.realTime.filter.user',
} as const;

/**
 * Initial SecondaryPanel filter shape for Work Journey Real-Time.
 * Values are applied client-side only (see FILTERS.md).
 */
export const INIT_WORK_JOURNEY_REAL_TIME_FILTERS: FilterValues = {
  [REAL_TIME_FILTER_FIELD.WORK_SHIFT]: {
    value: '',
    label: translateString('workJourney.realTime.filter.shift'),
    valueType: 'string',
  },
  [REAL_TIME_FILTER_FIELD.WORK_JOURNEY]: {
    value: '',
    label: translateString('workJourney.realTime.filter.journey'),
    valueType: 'string',
  },
  [REAL_TIME_FILTER_FIELD.USER]: {
    value: '',
    label: translateString('workJourney.realTime.filter.user'),
    valueType: 'string',
  },
  [REAL_TIME_FILTER_FIELD.STATUS]: {
    value: '',
    label: translateString('workJourney.realTime.filter.status'),
    valueType: 'string',
  },
  [REAL_TIME_FILTER_FIELD.COST_CENTERS]: {
    value: [],
    label: translateString('costCenters.filter.label'),
    valueType: 'array',
  },
};

/** Merges a consistent structural selection into the current panel values (keeps status). */
export const mergeRealTimeStructuralSelection = (
  current: FilterValues,
  selection: RealTimeStructuralSelection,
  translatedValues: RealTimeStructuralSelection,
  fieldLabels: RealTimeStructuralSelection,
): FilterValues => ({
  ...INIT_WORK_JOURNEY_REAL_TIME_FILTERS,
  ...current,
  [REAL_TIME_FILTER_FIELD.WORK_SHIFT]: {
    ...INIT_WORK_JOURNEY_REAL_TIME_FILTERS[REAL_TIME_FILTER_FIELD.WORK_SHIFT],
    ...current[REAL_TIME_FILTER_FIELD.WORK_SHIFT],
    value: selection.workShiftId,
    label: fieldLabels.workShiftId,
    valueTranslated: translatedValues.workShiftId,
    valueType: 'string',
  },
  [REAL_TIME_FILTER_FIELD.WORK_JOURNEY]: {
    ...INIT_WORK_JOURNEY_REAL_TIME_FILTERS[REAL_TIME_FILTER_FIELD.WORK_JOURNEY],
    ...current[REAL_TIME_FILTER_FIELD.WORK_JOURNEY],
    value: selection.workJourneyConfigId,
    label: fieldLabels.workJourneyConfigId,
    valueTranslated: translatedValues.workJourneyConfigId,
    valueType: 'string',
  },
  [REAL_TIME_FILTER_FIELD.USER]: {
    ...INIT_WORK_JOURNEY_REAL_TIME_FILTERS[REAL_TIME_FILTER_FIELD.USER],
    ...current[REAL_TIME_FILTER_FIELD.USER],
    value: selection.employeeId,
    label: fieldLabels.employeeId,
    valueTranslated: translatedValues.employeeId,
    valueType: 'string',
  },
});
